export default {"src":"/_next/static/media/target-cursor.3451ec07.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};